import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../context/UserContext';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles }) => {
  const { isLoggedIn, isLoading, userDetails } = useContext(UserContext);
  const [continueURL, setContinueURL] = useState(null);

  useEffect(() => {
    if (isLoading) {
      setContinueURL(window.location.href);
    }
  }, [isLoading]);

  if (isLoading) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          backgroundColor: '#161616',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      ></div>
    );
  }

  // restrict the routes based on the user role
  if (isLoggedIn && userDetails && !allowedRoles.includes(userDetails?.role)) {
    return <Navigate to="/" replace />;
  }

  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate
      to={`/login?continueURL=${encodeURIComponent(continueURL)}`}
      replace
    />
  );
};

export default ProtectedRoute;
